// ==========================================================================
// Generated Link Service - reports PWA clicks back to the backend
// Endpoint: POST /api/generated-links/clicks
// ==========================================================================

import api from '@/lib/axios';

export interface RecordClickRequest {
  slug: string;
  channel?: 'pwa';
}

/**
 * Fire-and-forget click log. The endpoint returns 204 even for unknown slugs;
 * any thrown error is swallowed so this never blocks the rest of app boot.
 */
export async function recordGeneratedLinkClick(slug: string): Promise<void> {
  try {
    await api.post('/generated-links/clicks', { slug, channel: 'pwa' } satisfies RecordClickRequest);
  } catch {
    // Click logging is observational; never disrupt boot if it fails.
  }
}
